import { LAST_YEAR_WEEKS_THURSDAY } from '@/pages/admin/ccWeeklyReport/helpers/lastYearWeeksThursday';
import { LAST_YEAR_WEEKS_WEDNESDAY } from '@/pages/admin/ccWeeklyReport/helpers/lastYearWeeksWednesday';

export const WEEKLY_THURSDAY_WEDNESDAY_PERIODS_OF_TIME_OPTIONS = {
	period_date_from: LAST_YEAR_WEEKS_THURSDAY,
	period_date_to: LAST_YEAR_WEEKS_WEDNESDAY,
};

export const DEFAULT_WEEKS_BACK = 10;
